/* The switch column of the Team list, shared by the header and every card so the two line up. */
export const SUPPORT_COLUMN = 'w-56 justify-center max-mobile:w-auto';
